<template>
  <div>
    <router-view/>
    <cookie-law :message="$t('cookie_consent.message')" :buttonText="$t('cookie_consent.button')" theme="fleetware"></cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import HotjarInitializer from './shared/initializers/HotjarInitializer'
import { callInitializers } from './shared/utils/common'

export default {
  name: 'App',
  components: { CookieLaw },

  async created () {
    document.head.prepend(document.createComment(` versions:
      smartcommerce-fleetware-ui@${process.env.APP_VERSION}
      smartcommerce-component-library@${process.env.COMPONENT_LIBRARY_VERSION}
    `))

    await callInitializers([HotjarInitializer])
  }
}
</script>

<style lang="scss">
.Cookie--fleetware {
  background: #E5F5CF;
  color: #599900;
  padding: 1.250em;

  .Cookie__button {
    background: #599900;
    padding: 0.625em 3.125em;
    color: white;
    border-radius: 5px;
    border: 0;
    font-size: 1em;
    &:hover {
      background: lighten(#599900, 3%);
    }
  }
}
</style>
